export default "__VITE_ASSET__BziobGcg__"